<template>
	<div class="full">
		<vxe-table :loading="loading" :data="data" height="90%" border :tooltip-config="{showAll:true}"
			:merge-cells="mergeCells">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="time" title="统计日期"></vxe-column>
			<vxe-column field="daterange" title="时段"></vxe-column>
			<vxe-column field="amount" title="销售金额"></vxe-column>
			<vxe-column field="size" title="销售数量"></vxe-column>
			<vxe-column field="count" title="近6个月销售次数"></vxe-column>
		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'salesstaticIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				data: [],
				mergeCells: [{
						row: 0,
						col: 5,
						rowspan: 3,
						colspan: 0
					}
				],
				loading: false
			}
		},
		watch: {
			
		},
		created() {

		},
		mounted() {
			if (this.row) {
				this.getStatic()
			}else{
				this.data = []
			}
		},
		computed: {

		},

		methods: {
			getStatic() {
				this.loading = true
				this.$api.goods.getStatic(this.row.id).then((res) => {
					let data = []
					if (res) {
						data.push({
							time: res.time,
							daterange: '近30天',
							amount: res.day_30 ? res.day_30.amount : 0,
							size: res.day_30 ? res.day_30.size : 0,
							count: res.day_30 ? res.day_30.count : 0,
						})
						data.push({
							time: res.time,
							daterange: '30~60天',
							amount: res.day_60 ? res.day_60.amount : 0,
							size: res.day_60 ? res.day_60.size : 0,
							count: res.day_60 ? res.day_60.count : 0,
						})
						data.push({
							time: res.time,
							daterange: '60~90天',
							amount: res.day_90 ? res.day_90.amount : 0,
							size: res.day_90 ? res.day_90.size : 0,
							count: res.day_90 ? res.day_90.count : 0,
						})
					}
					this.data = data
					this.loading = false
				}, () => {
					this.loading = false
				})
			},

		},
		components: {

		}
	}
</script>